const desktopVariants = {
  NR136: {
    fontSize: 136,
    letterSpacing: -5.4,
    fontWeight: 300,
  },
  NR106: {
    fontSize: 106,
    letterSpacing: -4.2,
    fontWeight: 500,
  },
  H1: {
    fontSize: 96,
    letterSpacing: -3.8,
    fontWeight: 100,
  },
  H2: {
    fontSize: 66,
    letterSpacing: -2.62,
    fontWeight: 100,
    lineHeight: 1.18,
  },
  NR64: {
    fontSize: 64,
    letterSpacing: -2.54,
    fontWeight: 300,
  },
  NR52: {
    fontSize: 52,
    letterSpacing: -2.06,
    fontWeight: 500,
    lineHeight: 0.54,
  },
  H3: {
    fontSize: 48,
    letterSpacing: -0.91,
    lineHeight: 1.13,
  },
  44: {
    fontSize: 44,
    letterSpacing: -0.83,
    fontWeight: 100,
    lineHeight: 1.07,
  },
  36: {
    fontSize: 36,
    letterSpacing: -0.7,
    lineHeight: 1.22,
  },
  Navigation: {
    fontSize: 36,
    lineHeight: 1.36,
    fontWeight: 300,
    color: 'white',
  },
  H4: {
    fontSize: 32,
    letterSpacing: -0.6,
    lineHeight: 1.34,
    fontWeight: 300,
  },
  H5: {
    fontSize: 26,
    letterSpacing: -0.3,
    lineHeight: 1.15,
    fontWeight: 100,
  },
  24: {
    fontSize: 24,
    letterSpacing: -0.86,
    lineHeight: 1.25,
    fontWeight: 100,
  },
  H6: {
    fontSize: 22,
    letterSpacing: -0.2,
    lineHeight: 1.09,
    fontWeight: 500,
  },
  19: {
    fontSize: 19,
    letterSpacing: -0.36,
    lineHeight: 1.26,
    fontWeight: 300,
  },
  Body1: {
    fontSize: 18,
    lineHeight: 1.56,
  },
  Body2: {
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: -0.3,
    fontWeight: 300,
  },
  Caption: {
    fontSize: 14,
    lineHeight: 1.43,
    fontWeight: 300,
  },
  Caption2: {
    fontSize: 13,
    lineHeight: 1.54,
    fontWeight: 300,
  },
  Overline: {
    fontSize: 12,
    lineHeight: 2.33,
    letterSpacing: 3,
  },
  OverlineCondensed: {
    fontSize: 12,
    lineHeight: 1.58,
    letterSpacing: 0.5,
    fontWeight: 100,
  },

  InputFieldLight: {
    fontSize: 16,
    letterSpacing: -0.3,
    lineHeight: 1.5,
    fontWeight: 100,
  },
};

const mobileVariants = {
  MobHeader3: {
    fontSize: 21,
    lineHeight: 1.24,
    letterSpacing: -0.13,
  },
  MobSmallTitles: {
    fontSize: 10,
    lineHeight: 1.6,
    letterSpacing: 2.5,
  },
};

export const keys = [
  'NR136',
  'NR106',
  'NR64',
  'NR52',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  '44',
  '36',
  '24',
  '19',
  'Navigation',
  'Body1',
  'Body2',
  'Caption',
  'Caption2',
  'Overline',
  'OverlineCondensed',

  'InputFieldLight',

  'MobHeader3',
  'MobSmallTitles',
];

export default {
  ...desktopVariants,
  ...mobileVariants,
};
